import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var MaintenancePage = React.lazy(function () { return import('../pages/maintenance/maintenance.page'); });
var maintenanceRedirectPages = [];
var userRolesArray = Object.values(UserRole);
var maintenanceRoutes = [
    {
        path: AppRoutes.MaintenancePage,
        element: (_jsx(RouteAuthorizer, { userRoles: userRolesArray, redirectPages: maintenanceRedirectPages, children: _jsx(MaintenancePage, {}) })),
    },
];
export default maintenanceRoutes;
